import { render, staticRenderFns } from "./nyhead.vue?vue&type=template&id=2738102b&scoped=true&"
import script from "./nyhead.vue?vue&type=script&lang=js&"
export * from "./nyhead.vue?vue&type=script&lang=js&"
import style0 from "./nyhead.vue?vue&type=style&index=0&id=2738102b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738102b",
  null
  
)

export default component.exports